import { useState,useEffect } from "react";
import { useAuthContext } from '../../adminlogin/useAuthContext';
import { useSubCasteContext } from "./useSubCasteContext";
import API_URL from "../../api/APIUrl";
import SideMenu from '../SideMenu';
import { Circles } from 'react-loader-spinner'

const AddSubCaste = () => {
    const {adminuser} = useAuthContext();
    const {dispatch} = useSubCasteContext();

    const [title,setTitle] = useState('');
    const [caste,setCaste] = useState('');
    const [allCastes,setAllCastes] = useState([]);
    const [casteError,setCasteError] = useState(null);

    const [error,setError] = useState(null);
    const [msg,setMsg] = useState(null);
    const [emptyFields,setEmptyFields] = useState([]);
    const [loading, setLoading] = useState(false); // Loading state

        
    const handleSubmit = async (e) => {
        
        e.preventDefault();
        setLoading(true); 

        try {
            if(!adminuser) {
                setLoading(false); 
                setError("You must be logged in");
                return;
            }
    
            const subcasteData = {title,caste};
    
            const response = await fetch(API_URL.POST_CREATE_SUBCASTE,{
                method: 'POST',
                headers:{
                    'Content-Type' : 'application/json',
                    'Authorization': `Bearer ${adminuser.token}` 
                },
               
                body: JSON.stringify(subcasteData),
               
               
            });
            const json = await response.json();
            if(!response.ok){
                setLoading(false); 
                setMsg('');
                setError(json.error);
                if(json.requiredFields){
                    setEmptyFields(json.requiredFields);
                    console.log(json.requiredFields);
                }               
            }
            if(response.ok){
                setLoading(false); 
                setTitle('');
                setCaste('');
                setError(null);
                setMsg(json.msg);
                setEmptyFields([]);
                console.log("New subcaste added",json);
                //dispatch({type:'CREATE_RELIGION',payload:json});
        
            }
        } catch (error) {
            setLoading(false); 
            setError(error.message);
        }

        

    }

    useEffect(()=>{
        const fetchAllCastes = async () => {
            const response = await fetch(API_URL.GET_ALL_CASTE);
            const json = await response.json();
    
            if(response.ok){
              setAllCastes(json);
            }
            else{
                setAllCastes(null);
              setCasteError('No caste data found!');
            }
        }

        fetchAllCastes();
    },[]);


    return (

        <div className="d-flex">
              <SideMenu />
              <div id="page-content-wrapper" style={{ flex: 1, padding: '20px' }}>
              <div className="container-fluid">

        <main className="form-signin">
                <div className="px-4 py-5 text-center" >
                {error && <div className="error-message">{error}</div>}
                {msg && <div className="success-message">{msg}</div>}
                 <form onSubmit={handleSubmit}>
                 <h1 className="h3 mb-3 fw-normal">Add SubCaste</h1>
                  
                    <div className="form-floating ">
                        <input 
                        type="text" 
                        id="titleLabel"
                        className={`form-control ${emptyFields.includes('title')? 'error':''}`}
                        onChange={(event)=> setTitle(event.target.value)}
                        value={title}
                        />
                        <label htmlFor="titleLabel">Title</label>
                    </div>
                    <div className="form-floating">
                            <select 
                            id="casteLabel"
                            className={`form-control ${emptyFields.includes('caste')? 'error':''}`}
                            onChange={(event)=> setCaste(event.target.value)}
                            value={caste}
                            >
                                <option value="">Select</option>
                                { allCastes && allCastes.map((rel) => (
                                     <option data-pg={rel.title} value={rel.title}>{rel.title}</option>
                                    ))
                                }
                            </select>
                            <label for="casteLabel">Caste</label>
                    </div>
                    <br></br>
                    <Circles
                            height="80"
                            width="80"
                            color="#4A90E2"
                            ariaLabel="circles-loading"
                            wrapperStyle={{justifyContent: "center",
                            alignItems: "center",}}
                            wrapperClass=""
                            visible={loading}
                            />              
                    <button className="btn btn-primary">Add SubCaste</button>
                  

                </form>
               </div>
            </main>

            </div>
            </div>

        </div>
           
    )

}

export default AddSubCaste;